angular.module('app.security', ['angular-ladda', 'ngDialog', 'hl.sticky']);
// angular.module('app.security').run(["$rootScope", "MetaTags",
//     function ($rootScope, MetaTags) {
//         $rootScope.MetaTags = MetaTags;
//     }
// ]);